module.exports = __webpack_public_path__ + "static/media/arrow-left.ebbeb235.svg";